import BlockWorkspace from './BlockWorkspace';
export default BlockWorkspace;
